const BaseComponent = require('@clubajax/base-component');

class UiArrow extends BaseComponent {}

module.exports = BaseComponent.define('ui-arrow', UiArrow, {});
